<template>
  <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/mod">월수익</router-link> |
    <router-link to="/end">수익</router-link> |
    <router-link to="/meritz">메리츠</router-link>|
    <router-link to="/system">모니터링</router-link>
  </nav>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

@import './assets/styles.css';
</style>
